/**
 * @generated SignedSource<<157ef8acf7153edc9fbaef95c4f005b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useRatesRelayByIdQuery$variables = {
  id: string;
};
export type useRatesRelayByIdQuery$data = {
  readonly getRate: {
    readonly activeOn: any | null | undefined;
    readonly archivedOn: any | null | undefined;
    readonly baseRate: number | null | undefined;
    readonly baseRateIncludedTime: number | null | undefined;
    readonly createdOn: any;
    readonly creditCardHold: number | null | undefined;
    readonly freeTime: number | null | undefined;
    readonly hidden: boolean | null | undefined;
    readonly id: string;
    readonly maxPeriods: number | null | undefined;
    readonly maxRentals: number | null | undefined;
    readonly membershipRequired: boolean;
    readonly minimumWalletDeposit: number | null | undefined;
    readonly name: string;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly periodDuration: number | null | undefined;
    readonly pricePerPeriod: number | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string;
  } | null | undefined;
};
export type useRatesRelayByIdQuery = {
  response: useRatesRelayByIdQuery$data;
  variables: useRatesRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Rate",
    "kind": "LinkedField",
    "name": "getRate",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baseRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baseRateIncludedTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "creditCardHold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "freeTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hidden",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPeriods",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxRentals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "membershipRequired",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minimumWalletDeposit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "periodDuration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricePerPeriod",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRatesRelayByIdQuery",
    "selections": (v4/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRatesRelayByIdQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "6c7c9fe39c05e2c122c9b33058f75190",
    "id": null,
    "metadata": {},
    "name": "useRatesRelayByIdQuery",
    "operationKind": "query",
    "text": "query useRatesRelayByIdQuery(\n  $id: ID!\n) {\n  getRate(id: $id) {\n    id\n    oldId\n    name\n    activeOn\n    archivedOn\n    baseRate\n    baseRateIncludedTime\n    creditCardHold\n    freeTime\n    hidden\n    maxPeriods\n    maxRentals\n    membershipRequired\n    minimumWalletDeposit\n    periodDuration\n    pricePerPeriod\n    systemId\n    systemOldId\n    organizationId\n    createdOn\n    system {\n      id\n      oldId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9f7b6c3a351754ad8a509f023276537";

export default node;
